import Link from 'next/link'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'

import styles from './Hero.module.scss'

export type HeroProps = {
    halfTitle?: string
    title?: string
    desc?: string
    bgImage?: string
    customClass?: string
    linkButton?: { label: string; link: string; variant: string }
    linkButton2?: { label: string; link: string; variant: string }
    children?: React.ReactNode
    childrenCol?: number
    col1?: number
    col2?: number
    colLg1?: number
    colLg2?: number
    isHeader?: boolean
}

export default function Hero({
    halfTitle,
    title,
    desc,
    bgImage,
    linkButton,
    linkButton2,
    customClass,
    col1,
    col2,
    colLg1,
    colLg2,
    children,
    childrenCol,
    isHeader,
}: HeroProps) {
    const componentClass = `Hero position-relative ${customClass ?? ''}`
    const childrenContentClass = `childrenContent ${styles.childrenContent}`

    return (
        <section className={componentClass}>
            <Row className="align-items-center">
                <Col className="content" md={col1} lg={colLg1}>
                    {halfTitle && <p className="half-title">{halfTitle}</p>}
                    {isHeader ? (
                        <h1
                            className="header-section-title mb-4"
                            dangerouslySetInnerHTML={{ __html: title ?? '' }}
                        ></h1>
                    ) : (
                        <h2
                            className="header-section-title section-title-h2 mb-4"
                            dangerouslySetInnerHTML={{ __html: title ?? '' }}
                        ></h2>
                    )}

                    {desc && <p className="mb-4">{desc}</p>}
                    {childrenCol && childrenCol === 1 && children}
                    {linkButton && (
                        <Link href={linkButton.link}>
                            <Button className={linkButton2 && 'me-4 mb-4 mb-lg-0'} variant={linkButton.variant}>
                                {linkButton.label}
                            </Button>
                        </Link>
                    )}
                    {linkButton2 && (
                        <Link href={linkButton2.link}>
                            <Button variant={linkButton2.variant}>{linkButton2.label}</Button>
                        </Link>
                    )}
                </Col>
                <Col
                    style={{ backgroundImage: bgImage ? `url("${bgImage}")` : 'none' }}
                    className={childrenContentClass}
                    md={col2}
                    lg={colLg2}
                >
                    {(!childrenCol || childrenCol === 2) && children}
                </Col>
            </Row>
        </section>
    )
}
